var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60817 16.416C6.2915 15.6827 7.33317 15.741 7.93317 16.541L8.77484 17.666C9.44984 18.5577 10.5415 18.5577 11.2165 17.666L12.0582 16.541C12.6582 15.741 13.6998 15.6827 14.3832 16.416C15.8665 17.9994 17.0748 17.4743 17.0748 15.2577V5.86602C17.0832 2.50768 16.2998 1.66602 13.1498 1.66602H6.84984C3.69984 1.66602 2.9165 2.50768 2.9165 5.86602V15.2493C2.9165 17.4743 4.13317 17.991 5.60817 16.416Z",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 5.83398H13.3332",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16602H12.5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionDetails);
export default __webpack_public_path__ + "static/media/transaction-details.39a5f112.svg";
export { ForwardRef as ReactComponent };